"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarTableModal = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../button");

var _form = require("../../form");

var _layout = require("../../layout");

var _liveAnnouncer = require("../../live-announcer");

var _messageBanner = require("../../message-banner");

var _modal = require("../../modal");

var _screenReaderOnly = require("../../screen-reader-only");

var _text = require("../../text");

var _utils = require("../../utils");

var _constants = require("./constants");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ToolbarTableModal = function ToolbarTableModal(_ref) {
  var isOpen = _ref.isOpen,
      close = _ref.close,
      onClose = _ref.onClose,
      setReturnFocus = _ref.setReturnFocus,
      localization = _ref.localization,
      onSetRowsAndColumns = _ref.onSetRowsAndColumns;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tableRowQuantity = _useState2[0],
      setTableRowQuantity = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      tableColumnQuantity = _useState4[0],
      setTableColumnQuantity = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      tableLabel = _useState6[0],
      setTableLabel = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      hasMissingRowError = _useState8[0],
      setHasMissingRowError = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      hasMissingColumnError = _useState10[0],
      setHasMissingColumnError = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      hasInvalidRowError = _useState12[0],
      setHasInvalidRowError = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      hasInvalidColumnError = _useState14[0],
      setHasInvalidColumnError = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
      hasMissingAltTitleError = _useState16[0],
      setHasMissingAltTitleError = _useState16[1];

  var _useState17 = (0, _react.useState)(false),
      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
      showCreateTableError = _useState18[0],
      setShowCreateTableError = _useState18[1];

  var _useState19 = (0, _react.useState)(false),
      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
      isMessageBannerAnnounced = _useState20[0],
      setIsMessageBannerAnnounced = _useState20[1];

  var firstInputRef = (0, _react.useRef)(null);
  var secondInputRef = (0, _react.useRef)(null);
  var thirdInputRef = (0, _react.useRef)(null);
  var modalTitleTextId = (0, _react.useMemo)(function () {
    return (0, _utils.getUniqueId)(_constants.TOOLBAR_MODAL_TITLE_ID);
  }, []);
  var closeDialogTextId = (0, _react.useMemo)(function () {
    return (0, _utils.getUniqueId)(_constants.TOOLBAR_MODAL_CLOSE_TEXT_ID);
  }, []);

  var labelTexts = _objectSpread(_objectSpread({}, _constants.toolbarTableModalDefaultProps.localization), localization);

  var createTableTitleText = labelTexts.createTableTitleText,
      rowQuantityTitleText = labelTexts.rowQuantityTitleText,
      altTitleText = labelTexts.altTitleText,
      accessibilityTitleText = labelTexts.accessibilityTitleText,
      modalDescriptionText = labelTexts.modalDescriptionText,
      columnQuantityText = labelTexts.columnQuantityText,
      cancelButtonText = labelTexts.cancelButtonText,
      confirmButtonText = labelTexts.confirmButtonText,
      closeDialogAltText = labelTexts.closeDialogAltText,
      rowErrorOnlyNumbersText = labelTexts.rowErrorOnlyNumbersText,
      columnErrorOnlyNumbersText = labelTexts.columnErrorOnlyNumbersText,
      inputErrorText = labelTexts.inputErrorText,
      inputErrorAltTitleText = labelTexts.inputErrorAltTitleText,
      createTableErrorText = labelTexts.createTableErrorText,
      dismissButtonAltText = labelTexts.dismissButtonAltText,
      messageBannerIconAltText = labelTexts.messageBannerIconAltText;

  var renderFooter = function renderFooter(_ref2) {
    var errorText = _ref2.errorText,
        footerProps = _ref2.footerProps,
        isError = _ref2.isError;

    if (isError) {
      return (0, _core.jsx)(_form.InputFooter, footerProps, (0, _core.jsx)(_form.InputFooterText, null, errorText));
    }

    return undefined;
  };

  var rowInputFooter = (0, _react.useMemo)(function () {
    return function (footerProps) {
      return renderFooter({
        footerProps: footerProps,
        isError: hasMissingRowError || hasInvalidRowError,
        errorText: hasMissingRowError ? inputErrorText : rowErrorOnlyNumbersText
      });
    };
  }, [hasMissingRowError, hasInvalidRowError, inputErrorText, rowErrorOnlyNumbersText]);
  var columnInputFooter = (0, _react.useMemo)(function () {
    return function (footerProps) {
      return renderFooter({
        footerProps: footerProps,
        isError: hasMissingColumnError || hasInvalidColumnError,
        errorText: hasMissingColumnError ? inputErrorText : columnErrorOnlyNumbersText
      });
    };
  }, [hasMissingColumnError, hasInvalidColumnError, inputErrorText, columnErrorOnlyNumbersText]);
  var altTextInputFooter = (0, _react.useMemo)(function () {
    return function (footerProps) {
      return renderFooter({
        footerProps: footerProps,
        isError: hasMissingAltTitleError,
        errorText: inputErrorAltTitleText
      });
    };
  }, [hasMissingAltTitleError, inputErrorAltTitleText]);

  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    var rowNotSet = tableRowQuantity === null;
    var columnNotSet = tableColumnQuantity === null;
    var rowIsInvalid = tableRowQuantity !== null && (isNaN(tableRowQuantity) || tableRowQuantity <= 0);
    var columnIsInvalid = tableColumnQuantity !== null && (isNaN(tableColumnQuantity) || tableColumnQuantity <= 0);
    var titleNotSet = tableLabel.trim() === '';
    setHasMissingRowError(rowNotSet);
    setHasMissingColumnError(columnNotSet);
    setHasMissingAltTitleError(titleNotSet);
    setHasInvalidRowError(rowIsInvalid);
    setHasInvalidColumnError(columnIsInvalid);

    if (rowNotSet || columnNotSet || rowIsInvalid || columnIsInvalid || titleNotSet) {
      handleFocusOnError(rowNotSet, columnNotSet, rowIsInvalid, columnIsInvalid, titleNotSet);
      return;
    }

    if (onSetRowsAndColumns !== undefined) {
      try {
        onSetRowsAndColumns(tableRowQuantity, tableColumnQuantity, tableLabel);
      } catch (error) {
        setShowCreateTableError(true);
      }
    }
  };

  var onColumnInputChange = function onColumnInputChange(e) {
    setHasMissingColumnError(false);
    setHasInvalidColumnError(false);
    setShowCreateTableError(false);

    if (e.target.value.trim() === '') {
      setTableColumnQuantity(null);
    } else {
      if (!isNaN(+e.target.value)) {
        setTableColumnQuantity(parseInt(e.target.value));
      } else {
        setTableColumnQuantity(NaN);
      }
    }
  };

  var onRowInputChange = function onRowInputChange(e) {
    setHasMissingRowError(false);
    setHasInvalidRowError(false);
    setShowCreateTableError(false);

    if (e.target.value.trim() === '') {
      setTableRowQuantity(null);
    } else {
      if (!isNaN(+e.target.value)) {
        setTableRowQuantity(parseInt(e.target.value));
      } else {
        setTableRowQuantity(NaN);
      }
    }
  };

  var onAltTextInputChange = function onAltTextInputChange(e) {
    setHasMissingAltTitleError(false);
    setTableLabel(e.target.value);
  };

  var handleFocusOnError = (0, _react.useCallback)(function (rowNotSet, columnNotSet, rowIsInvalid, columnIsInvalid, titleNotSet) {
    if ((rowNotSet || rowIsInvalid) && firstInputRef.current) {
      firstInputRef.current.focus();
    } else if ((columnNotSet || columnIsInvalid) && secondInputRef.current) {
      secondInputRef.current.focus();
    } else if (titleNotSet && thirdInputRef.current) {
      thirdInputRef.current.focus();
    }
  }, []);
  var handleDismiss = (0, _react.useCallback)(function () {
    setShowCreateTableError(false);

    if (isOpen && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [isOpen]);

  var handleClose = function handleClose() {
    if (!isOpen) {
      setHasMissingRowError(false);
      setHasMissingColumnError(false);
      setHasInvalidColumnError(false);
      setHasInvalidRowError(false);
      setHasMissingAltTitleError(false);
      onClose();
    }
  };

  var messageBanner = (0, _react.useMemo)(function () {
    return showCreateTableError ? (0, _core.jsx)(_liveAnnouncer.LiveAnnouncer, null, (0, _core.jsx)(_liveAnnouncer.LiveRegion, {
      "aria-live": "polite",
      role: _liveAnnouncer.LiveRegionRole.Status
    }, (0, _core.jsx)(_messageBanner.MessageBanner, {
      type: _messageBanner.MessageBannerType.Error,
      isDismissible: true,
      onDismissed: handleDismiss,
      dismissButtonAltText: dismissButtonAltText,
      iconAltText: messageBannerIconAltText
    }, createTableErrorText))) : null;
  }, [showCreateTableError, handleDismiss, dismissButtonAltText, messageBannerIconAltText, createTableErrorText]);
  (0, _react.useEffect)(function () {
    if (isOpen && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    if (messageBanner && !isMessageBannerAnnounced) {
      setIsMessageBannerAnnounced(true);
    }
  }, [messageBanner, isMessageBannerAnnounced]);
  return (0, _core.jsx)(_modal.Modal, {
    "aria-labelledby": modalTitleTextId,
    setReturnFocus: setReturnFocus,
    close: close,
    onClose: handleClose,
    isOpen: isOpen
  }, (0, _core.jsx)("form", {
    onSubmit: onSubmit,
    noValidate: true,
    autoComplete: "off"
  }, (0, _core.jsx)(_form.FormWrapper, {
    width: _constants.TOOLBAR_MODAL_WIDTH,
    maxWidth: "100%"
  }, (0, _core.jsx)(_modal.ModalContent, {
    maxWidth: _constants.TOOLBAR_MODAL_WIDTH,
    titleTextId: modalTitleTextId,
    titleText: createTableTitleText,
    buttons: [(0, _core.jsx)(_button.Button, {
      key: "cancel-button",
      variant: _button.ButtonVariant.Tertiary,
      onClick: close,
      "aria-describedby": closeDialogTextId
    }, cancelButtonText), (0, _core.jsx)(_button.Button, {
      key: "confirm-button",
      variant: _button.ButtonVariant.Primary,
      type: "submit",
      "aria-describedby": closeDialogTextId
    }, confirmButtonText)]
  }, (0, _core.jsx)(_layout.Col, {
    gridGap: "S300"
  }, (0, _core.jsx)(_form.InputWrapper, {
    id: "row-input",
    labelText: rowQuantityTitleText,
    required: true,
    error: hasMissingRowError || hasInvalidRowError,
    footer: function footer(footerProps) {
      return rowInputFooter(footerProps);
    }
  }, function (inputProps) {
    return (0, _core.jsx)(_form.Input, (0, _extends2.default)({}, inputProps, {
      type: "text",
      onChange: function onChange(e) {
        onRowInputChange(e);
      },
      ref: firstInputRef
    }));
  }), (0, _core.jsx)(_form.InputWrapper, {
    id: "column-input",
    labelText: columnQuantityText,
    required: true,
    error: hasMissingColumnError || hasInvalidColumnError,
    footer: function footer(footerProps) {
      return columnInputFooter(footerProps);
    }
  }, function (inputProps) {
    return (0, _core.jsx)(_form.Input, (0, _extends2.default)({}, inputProps, {
      type: "text",
      ref: secondInputRef,
      onChange: function onChange(e) {
        onColumnInputChange(e);
      }
    }));
  }), (0, _core.jsx)(_text.H3, {
    fontSize: "T300",
    fontWeight: "bold"
  }, accessibilityTitleText), (0, _core.jsx)(_text.Text, null, modalDescriptionText), (0, _core.jsx)(_form.InputWrapper, {
    id: "label-input",
    labelText: altTitleText,
    required: true,
    error: hasMissingAltTitleError,
    footer: function footer(footerProps) {
      return altTextInputFooter(footerProps);
    }
  }, function (inputProps) {
    return (0, _core.jsx)(_form.Input, (0, _extends2.default)({}, inputProps, {
      type: "text",
      ref: thirdInputRef,
      onChange: function onChange(e) {
        onAltTextInputChange(e);
      }
    }));
  })), messageBanner && (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_layout.Spacer, {
    height: "S500"
  }), messageBanner), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    id: closeDialogTextId,
    hidden: true
  }, closeDialogAltText)))));
};

exports.ToolbarTableModal = ToolbarTableModal;